import PropTypes from 'prop-types';
// @mui
import { Box, Stack, Typography, useTheme } from '@mui/material';
// hooks
import useLocales from '../hooks/useLocales';
// routes
// ----------------------------------------------------------------------

Copyright.propTypes = {
  sx: PropTypes.object,
};

export default function Copyright({ sx = {} }) {
  const { translate } = useLocales();
  const theme = useTheme();

  return (
    <Stack spacing={3} sx={{ textAlign: 'center', display: 'block', ...sx }}>
      <Typography component={'div'} variant="body2" sx={{ color: theme.palette.grey[500] }}>
        <Box>
          {translate('copyright.copyright')}{' '}
          <Typography component={'span'} variant={'body1'}>
            ©
          </Typography>
          <Typography component={'span'} sx={{ fontWeight: 500 }}>
            JMT Tech
          </Typography>
          . {translate('copyright.all_rights_reserved')}
        </Box>
      </Typography>
    </Stack>
  );
}
